// The brand shown in both apps: name, logo files and tagline. White-label ready (14B): a
// reseller gets its own folder under ui/brand/ and its own entry here, plus a block of token
// overrides in ui/tokens.css (:root[data-brand="…"]). Choosing a brand per domain comes later.
import emblem192 from './brand/fleetfunctions/emblem-192.png';
import emblem64 from './brand/fleetfunctions/emblem-64.png';
import logoWide from './brand/fleetfunctions/logo-wide.png';

export interface Brand {
  id: string;
  name: string;
  tagline: string;
  logoWide: string;   // full wordmark, transparent PNG (works on light and dark)
  emblem: string;     // round mark, for the navigation rail and small places
  emblemLarge: string;
}

export const BRAND: Brand = {
  id: 'fleetfunctions',
  name: 'Fleet Functions',
  tagline: 'Vehicle tracking solutions',
  logoWide,
  emblem: emblem64,
  emblemLarge: emblem192,
};
